<template>
  <v-img @click="$router.push({path: to})" :title="$lang.home" :aspect-ratio="16/9" :src="backgroundImage" :class="['app-avatar', 'text-xs-center']">
    <v-icon :color="iconColor" :size="`${iconSize}em`" :class="['mt-3', 'item-clickable']">{{ icon }}</v-icon>
  </v-img>
</template>
<script>
export default {
  name: 'AppAvatar',
  props: {
    /**
     * Icon size in em-units
     */
    iconSize: {
      type: Number,
      default: 10,
      required: false
    },
    /**
     * Icon color
     */
    iconColor: {
      type: String,
      default: null,
      required: false
    },
    /**
     * Background image
     */
    backgroundImage: {
      type: String,
      required: false,
      default: '/static/images/app-avatar.jpg'
    },
    /**
     * Click URL
     */
    to: {
      type: String,
      required: false,
      default: '/'
    },
    /**
     * Icon
     */
    icon: {
      type: String,
      default: 'mdi-home',
      required: false
    }
  }
}
</script>
<style>
.app-avatar
{
  filter: brightness(164%)
    contrast(100%)
    sepia(0%)
    saturate(0%)
    hue-rotate(0deg)
    invert(100%)
    opacity(100%)
    grayscale(100%)
    blur(0px);
}

.app-avatar .v-icon
{
  opacity: .75;
}
</style>



// WEBPACK FOOTER //
// src/components/app-avatar.vue